import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Typography, Stack, Button } from "@financeable-com-au/financeable-ui";
import { templatesSelector, getDocTemplatesFromTemplateType } from "@/store/slices/templatesSlice";
import { SIGNATURE_TYPE } from "@/constants";
// @ts-expect-error: ignoring as it is existing js file
import { getStringTitleCase } from "@/components/Utils/helperFunction";
import { useBrowserDetection } from "@/hooks/useBrowserDetection";
// @ts-expect-error: ignoring as it is existing js file
import { setIntercomChatOptions } from "@/store/slices/applicationFormSlice";
import PDFPreviewer from "@/components/Previews/PDFPreviewer";

type SignatureType = (typeof SIGNATURE_TYPE)[keyof typeof SIGNATURE_TYPE];

interface serviceAgreementProps {
  params: {
    cid: string;
    aid: string;
    uid: string;
    templateType: string;
    jwt: string;
  };
  serviceAgreementType: SignatureType;
}

interface DocumentTemplate {
  document: {
    template: string;
    status: string;
  };
}

const ServiceAgreement = ({ params, serviceAgreementType }: serviceAgreementProps) => {
  const dispatch = useDispatch();
  const template = useSelector(templatesSelector);
  const { document } = template as unknown as DocumentTemplate;
  const { cid, aid, uid, templateType, jwt } = params;
  const { isLegacySafari, supportsPromiseWithResolvers } = useBrowserDetection();
  const pdfPreviewerSupported = !isLegacySafari && supportsPromiseWithResolvers;

  useEffect(() => {
    dispatch(
      getDocTemplatesFromTemplateType({
        customerId: cid,
        applicationId: aid,
        userId: uid,
        templateType,
        jwt,
      }),
    );
  }, []);

  const handleContactSupport = () => {
    dispatch(
      setIntercomChatOptions({
        showIntercom: true,
        intercomData: {
          user_id: cid,
          name: "",
          email: "",
        },
        service: "viewing the privacy statement",
      }),
    );
  };

  return (
    <Accordion style={{ position: "static", margin: 0 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography level="body-md">Show {getStringTitleCase(serviceAgreementType) || "Service"} Statement</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {document.status === "fulfilled" && pdfPreviewerSupported ? (
          <PDFPreviewer s3Url={document.template} />
        ) : (
          <Stack rowGap={4}>
            <Typography level="body-sm">
              Unfortunately, your browser does not support viewing the PDF. Try upgrading your browser or contact one of
              our friendly members to help.
            </Typography>
            <Button variant="secondary" onClick={handleContactSupport}>
              Contact Support
            </Button>
          </Stack>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default ServiceAgreement;
